import React, { useEffect, useState, useContext } from 'react';

import QuillToolbar from './QuillToolbar';

//Quill
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { AdminContext } from '../../../../context/AdminContext';

import { BLOCK_LENGTH, FORMATS, MODULES_QUILL } from '../../../../constants/admin/blog_constants';

import {
    Box, Button, Dialog, DialogActions, DialogContent,
    DialogTitle, FormControl, InputLabel, Select,
    MenuItem, Grid, Card, CardMedia
} from '@mui/material';

const QuillEditDialog = ({ open, setOpen, row, setRow }) => {
    const { data: { blockState } } = useContext(AdminContext);
    const { item, src, type, xs, md, id, cloud_file } = blockState;
    const [text, setText] = useState('');
    const [colXS, setXS] = useState(12);
    const [colMD, setMD] = useState(6);

    useEffect(() => {
        if (type === 'txt')
            setText(item);
        setXS(xs);
        setMD(md);
    }, [item, open]);

    // campo Quill Editor
    const handleChange = (html) => {
        setText(html);
    };

    // cerrar Dialog
    const handleClose = () => {
        setOpen(false);
    };

    // cambiar longitud en vista escritorio
    const handleDesktopView = ({ target }) => {
        setMD(target.value);
    };
    // cambiar longitud en vista móvil
    const handleMovilView = ({ target }) => {
        setXS(target.value);
    };

    // actualizar bloque de Quill
    const updateBlock = () => {
        const content = row.map(e => (
            {    
                ...e,
                col: [
                    ...e.col.map(u => u.id === id ?
                        {
                            ...u,
                            // bloque de texto o archivo
                            item: type === 'text' ? text : item,
                            xs: colXS, md: colMD
                        }
                    :
                        u
                    )
                ]
            }
        ));
        setRow(content);
        handleClose();
    };

    return (
        <Dialog
            open={ open }
            onClose={ handleClose }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { width: '100%' } }}>
            <DialogTitle id="alert-dialog-title">
                Contenido de bloque
            </DialogTitle>
            <DialogContent>
                {
                    type === 'txt' &&
                        <Box>
                            <QuillToolbar />
                            <ReactQuill
                                value={text}
                                onChange={handleChange}
                                modules={MODULES_QUILL}
                                formats={FORMATS}
                            />
                        </Box>
                }
                {
                    (['img', 'video'].includes(type) && cloud_file) &&
                        <div className="myClass" dangerouslySetInnerHTML={{ __html: item }}></div>
                }
                {
                    (['img', 'video'].includes(type) && !cloud_file) &&
                        <Card>
                            <CardMedia
                                image={src}
                                title="Vista previa archivo"
                                component='img'
                            />
                        </Card>
                }

                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        {/* Longitud de escritorio */}
                        <FormControl fullWidth variant="standard">
                            <InputLabel id="md-select-label">Longitud de bloque en escritorio</InputLabel>
                            <Select
                                labelId="md-select-label"
                                id="md-select"
                                value={ colMD }
                                label="Longitud de bloque en escritorio"
                                onChange={ handleDesktopView }>
                                {
                                    BLOCK_LENGTH.map(e =>
                                        <MenuItem key={e}
                                            value={e}>{e}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        {/* Longitud de móviles */}
                        <FormControl fullWidth variant="standard">
                            <InputLabel id="xs-select-label">Longitud de bloque en móviles</InputLabel>
                            <Select
                                labelId="xs-select-label"
                                id="xs-select"
                                value={ colXS }
                                label="Longitud de bloque en móviles"
                                onChange={ handleMovilView }>
                                {
                                    BLOCK_LENGTH.map(e =>
                                        <MenuItem key={e}
                                            value={e}>{e}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleClose }>Cancelar</Button>
                <Button onClick={ updateBlock } autoFocus>
                    Actualizar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default QuillEditDialog;